import React from "react";
import { Radio, Button, Tooltip } from "antd";
import { Views } from "react-big-calendar";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { ScheduleOutlined } from "@ant-design/icons";
import Header from "./Header";
import PatientDetails from "./PatientDetails";
import { useMedia } from "react-media";
const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 899px)",
};

const SchedulingHeader = (props) => {
  const {
    calenderView,
    currentDate,
    onChangeView,
    effective_orders,
    order_time_extractions,
    ordersPalette,
    onFilterOrdersChanged,
    onNextDate,
    onPreviousDate,
    onlaunchApprovalModal,
    showPatientDetails,
    fullScreenModal,
    events,
    filteredOrders,
  } = props;
  const intl = useIntl();
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "flex-end",
        minWidth: 0, // Allow container to shrink below content size
        overflow: "hidden", // Prevent overflow
      }}
    >
      <div
        style={{
          flex: "1 1 auto",
          minWidth: 0, // Allow shrinking
          marginRight: "10px",
        }}
      >
        <Header
          currentDate={currentDate}
          effective_orders={effective_orders}
          order_time_extractions={order_time_extractions}
          ordersPalette={ordersPalette}
          onFilterOrdersChanged={onFilterOrdersChanged}
          onNextDate={onNextDate}
          onPreviousDate={onPreviousDate}
          calenderView={calenderView}
          fullScreenModal={fullScreenModal}
          events={events}
          filteredOrders={filteredOrders}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          width: "220px", // Increased fixed width
          flexShrink: 0, // Prevent shrinking
          marginLeft: "10px", // Add some spacing
        }}
      >
        {matches.small || !showPatientDetails ? null : (
          <div style={{ paddingBottom: "10px" }}>
            <PatientDetails record={activePatient} />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            minWidth: "220px", // Ensure minimum width for radio buttons
          }}
        >
          <Radio.Group onChange={onChangeView} value={calenderView}>
            <Radio.Button value={Views.DAY}>
              {intl.formatMessage({
                id: "app.scheduling.day",
              })}
            </Radio.Button>
            <Radio.Button value={Views.WEEK}>
              {intl.formatMessage({
                id: "app.scheduling.week",
              })}
            </Radio.Button>
            <Radio.Button value={Views.MONTH}>
              {intl.formatMessage({
                id: "app.scheduling.month",
              })}
            </Radio.Button>
          </Radio.Group>
          <Tooltip
            title={intl.formatMessage({
              id: "app.scheduling.approval",
            })}
          >
            <Button
              type="text"
              icon={<ScheduleOutlined />}
              onClick={() => onlaunchApprovalModal()}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default SchedulingHeader;
